import React from 'react';
import ShownPopupsContainer from '../containers/shown_popups_container';

const ShownPopupsContext = React.createContext(new ShownPopupsContainer());

export default ShownPopupsContext;
